import { inheritsLoose as _inheritsLoose, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, objectSpread2 as _objectSpread2, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { handleEvent, mapToCssModules, mergeCssModules } from '@emoney/kyber-helpers';
import classNames$1 from 'classnames';
import React__default, { PureComponent } from 'react';
import { withAnalytics } from '@emoney/kyber-analytics';
import { constructPropertyDrivenFieldClassName } from '../utils/formFieldUtils.js';
import Input$1 from '../Input/Input.js';
import '../Input/index.js';
import InputGroup$1 from '../InputGroup/InputGroup.js';
import '../InputGroup/index.js';
import InputGroupAddOn$1 from '../InputGroupAddOn/InputGroupAddOn.js';
import '../InputGroupAddOn/index.js';
import textfieldAnalytics from './textfield.analytics.js';
import defaultCssModule from './text-field.module.less.js';

/**
 * TextField is intended for single line string input on a form. No formatting is applied.
 */

var TextField = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(TextField, _PureComponent);

  function TextField() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      focused: typeof _this.props.focused !== 'undefined' ? _this.props.focused : false
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event, opts) {
      _this.setState({
        focused: true
      });

      handleEvent({
        event: event,
        method: 'onFocus',
        props: _this.props,
        payload: _objectSpread2(_objectSpread2({}, opts), {}, {
          value: _this.props.value
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event, opts) {
      _this.setState({
        focused: false
      });

      handleEvent({
        event: event,
        method: 'onBlur',
        props: _this.props,
        payload: _objectSpread2({}, opts)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFieldClasses", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          cssModule = _this$props.cssModule,
          restProps = _objectWithoutPropertiesLoose(_this$props, ["className", "cssModule"]);

      var focused = _this.state.focused;
      return mapToCssModules(classNames$1('field', constructPropertyDrivenFieldClassName(_objectSpread2(_objectSpread2({}, restProps), {}, {
        focused: focused
      }))), cssModule);
    });

    _defineProperty(_assertThisInitialized(_this), "saveRef", function (ref) {
      _this.props.saveRef(ref); // This is needed to work with AriaComboBox


      _this.props.innerRef && _this.props.innerRef(ref); //eslint-disable-line
    });

    return _this;
  }

  var _proto = TextField.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.focused !== this.props.focused) {
      this.setState({
        focused: this.props.focused
      });
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        analytics = _this$props2.analytics,
        className = _this$props2.className,
        cssModuleProp = _this$props2.cssModule,
        signLeft = _this$props2.signLeft,
        saveRef = _this$props2.saveRef,
        focused = _this$props2.focused,
        large = _this$props2.large,
        innerRef = _this$props2.innerRef,
        restProps = _objectWithoutPropertiesLoose(_this$props2, ["analytics", "className", "cssModule", "signLeft", "saveRef", "focused", "large", "innerRef"]);

    var cssModule = mergeCssModules(cssModuleProp, defaultCssModule);
    var classes = this.getFieldClasses();
    var inputClasses = mapToCssModules(classNames$1(className, classes), cssModule);
    var wrapperClasses = mapToCssModules(classes, cssModule);
    var textField = /*#__PURE__*/React__default.createElement(Input$1, _extends({}, restProps, {
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      className: inputClasses,
      analytics: null,
      ref: this.saveRef
    }));
    return signLeft ? /*#__PURE__*/React__default.createElement(InputGroup$1, {
      id: restProps.id + "-group"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: cssModule['control-group']
    }, /*#__PURE__*/React__default.createElement("div", {
      className: wrapperClasses
    }, /*#__PURE__*/React__default.createElement(InputGroupAddOn$1, {
      id: restProps.id + "-group-addon",
      className: cssModule['text-field-addon'],
      "aria-hidden": "true"
    }, signLeft), textField))) : textField;
  };

  return TextField;
}(PureComponent);
TextField.defaultProps = {
  type: 'text',
  analytics: textfieldAnalytics,
  saveRef: function saveRef() {},
  value: ''
};
TextField.displayName = 'TextField';
var TextField$1 = withAnalytics(TextField);

export default TextField$1;
export { TextField };
